import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames/bind';
import { priceToString } from '../../../../utils';
import { findDiscountTier } from '../../../../utils/aov';
import styles from './FreeGiftAOVDescription.module.scss';
import { COLOR_ATTRIBUTES, SIZE_ATTRIBUTES } from '../../constants';
import { GiftItem, Price } from '../types';

const FreeGiftAOVDescription = ({
  item,
}: {
  item: GiftItem;
}) => {
  const { locale, formatNumber, formatMessage } = useIntl();
  const cx = classnames.bind(styles);

  const { discount } = findDiscountTier(
    item.variants?.[0].discountsTier,
    1,
  ) as { discount: Price | null };
  const isDiscounted = !!discount?.centAmount;

  const size = item?.variants[0].attributes.find((attr) =>
    SIZE_ATTRIBUTES.includes(attr.name),
  );
  const color =
    size?.name !== SIZE_ATTRIBUTES[1]
      ? item?.variants[0].attributes.find((attr) =>
          COLOR_ATTRIBUTES.includes(attr.name),
        )?.label
      : undefined;

  return (
    <div className={styles['free-items-list']}>
      <div className={styles.item} key={item.productKey}>
        <div className={styles['item-title']}>
          {item?.productName[locale]}
        </div>
        <div className={styles['item-attributes']}>
          {size?.label}
          {color && size?.label && ` | ${color}`}
        </div>
        <div className={styles['item-description']}>
          {item?.description[locale]}
        </div>
        <div className={styles['item-price']}>
          <span className={cx('item-total-price', {
              strkethrough: isDiscounted
            })}>
              {priceToString({
                formatNumber,
                formatMessage,
                maximumFractionDigits: 0,
                price: {
                  ...item.variants?.[0]?.price,
                  centAmount:
                    (item.variants?.[0]?.price?.centAmount ?? 0) * (item.maxQuantity ?? 1),
                },
                forceDigit: false,
              })}
            </span>
            {isDiscounted && (
              <span className={styles['item-discounted-price']}>
                {priceToString({
                  formatNumber,
                  formatMessage,
                  maximumFractionDigits: 0,
                  price: {
                    ...item.variants?.[0]?.price,
                    centAmount:
                      ((item.variants?.[0]?.price?.centAmount ?? 0) -
                      (discount?.centAmount ?? 0)) * (item.maxQuantity ?? 1),
                  },
                  forceDigit: false,
                })}
              </span>
            )}
        </div>
      </div>
    </div>
  );
};
export default FreeGiftAOVDescription;
